import { render, staticRenderFns } from "./shopping.vue?vue&type=template&id=d83da0da&scoped=true"
import script from "./shopping.vue?vue&type=script&lang=js"
export * from "./shopping.vue?vue&type=script&lang=js"
import style0 from "./shopping.vue?vue&type=style&index=0&id=d83da0da&prod&lang=css"
import style1 from "./shopping.vue?vue&type=style&index=1&id=d83da0da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83da0da",
  null
  
)

export default component.exports